import React from 'react';
import { formatBadgeCount, shouldShowBadge } from '../../services/homeUnreadService';

/**
 * Ungelesen-Badge (2026-09-03): runder türkiser Punkt mit dunkler Zahl,
 * „99+" ab Cap, nichts bei 0. Wie in der App.
 */
const UnreadBadge: React.FC<{ count: number; cap?: number; className?: string }> = ({ count, cap, className = '' }) => {
  if (!shouldShowBadge(count)) return null;
  const label = formatBadgeCount(count, cap);
  return (
    <span
      data-testid="unread-badge"
      aria-label={`${label} ungelesen`}
      className={`inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#3fced1] px-1.5 text-[10.5px] font-extrabold leading-none text-[#1f1f1f] ${className}`}
    >
      {label}
    </span>
  );
};

export default UnreadBadge;
